webpackJsonp([265014790887498],{

/***/ 2012:
/***/ (function(module, exports) {

	module.exports = {"data":{"doc":{"id":"/docs/providers/azure/cli-reference/login/","frontmatter":{"title":"Serverless Framework Commands - Login","menuText":"login","layout":"Doc","menuOrder":6,"gitLink":"/docs/providers/azure/cli-reference/login.md","description":"Login to the serverless platform","menuItems":null},"content":"<h1 id=\"login\"><a href=\"#login\" class=\"phenomic-HeadingAnchor\">#</a>Login</h1>\n<p>The <code>login</code> command logs users into the serverless platform.</p>\n<p>It will create a new serverless platform account if one doesn't already exist.</p>\n<pre><code class=\"hljs language-bash\">serverless login\n\n<span class=\"hljs-comment\"># Shorthand</span>\nsls login</code></pre>\n"}},"pathContext":{"docId":"/docs/providers/azure/cli-reference/login/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---framework-docs-providers-azure-cli-reference-login-2ed4325c6a5a5167910e.js